import { css } from 'lit';

export default css`
  .cards {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
  }

  amityeko-skeleton {
    margin-bottom: 16px;
  }

  amityeko-skeleton:not(:nth-child(3n)) {
    margin-right: 16px;
  }

  rnr-client-badge-card {
    margin-bottom: 16px;
  }

  rnr-client-badge-card:not(:nth-child(3n)) {
    margin-right: 16px;
  }
`;
